export const api_constants = Object.freeze({
  login: 'admin/login',
  profileDetail: 'admin/profile',
  generate_otp: 'auth/generate-otp',
  otp_verification: 'auth/otp-verification',
  reset_password: 'auth/reset-password',
  list_bingo_card: 'admin/bingo-cards',
  enable_disable_bingo_card: 'admin/enable-disable-card',
  create_bingo_loaction: 'admin/bingo-location',
  delete_location: 'admin/location',
  user_list: 'admin/users',
  user_detail: 'admin/user',
  enable_disable_user: 'admin/enable-disable-user',
  user_card_detail: 'admin/user-cards',
  top_user: 'admin/top-users',
  user_reports: 'admin/user-reports',
  card_purchase_report: 'admin/card-purchase-reports',
  enable_disable_location: 'admin/enable-disable-location',
  preurlrequest: 'auth/pre-url-request',
  profile_delete_request: 'auth/delete-request',
  change_password: 'auth/change-password',
  bingo_card_detail: 'admin/bingo-card',
  update_location: 'admin/location',
  location_card_detail: 'admin/location-detail',
  sequence_list: 'admin/sequences',
  remove_bingo_card: 'admin/remove-card',
  delete_request: 'admin/delete-requests',
  user_login: 'user/login',
  reason: 'auth/delete-request',
  status_request: 'admin/delete-request',
  user_profile: 'user/user-profile',
  push_notification: 'admin/push-notification',
  checkin_list: 'admin/checkin-requests',
  checkin_deatil: 'admin/checkin-request',
  push_notification_list: 'admin/push-notification',
  edit_push_notification: 'admin/message',
  user_select_dropdown: 'admin/user-dropdown',
  activity_list_dropdown: 'admin/user-preferences',
  list_fun_activity_cards: 'admin/fun-activity',
  create_fun_activity_card: 'admin/create-fun-activity',
  fun_activity_category:'admin/fun-activity-category',
  create_sub_fun_activity:'admin/create-sub-activities',
  list_sub_fun_activity:'admin/activity',
  enable_disable_fun_activity_card:'admin/enable-disable-fun-activity-card',
  fun_activity_sequence:'admin/fun-activity-sequences',
  update_fun_activity_card:'admin/update-fun-activity',
  delete_fun_activity_card:'admin/delete-fun-activity',
  update_sub_fun_activity:'admin/update-sub-activity',
  delete_sub_fun_activity:'admin/delete-sub-activity',
  fun_activity_card_detail:'fun-activity/fun-activity',
  sub_fun_activity_detail:'fun-activity/activities-detail',
  update_bingo_category:'admin/bingo-card-category',
  quest_list:'admin/quest-list',
  create_quest:'admin/create-quest',
  create_icon:'admin/create-icon',
  icon_list:'admin/get-icons',
  quest_detail:'admin/quest-detail',
  quest_update:'admin/edit-quest',
  quest_delete:'admin/delete-quest',
  list_patches:'admin/list-badges',
  create_patch:'admin/create-badges',
  update_patches:'admin/update-badge',
  delete_patches:'admin/delete-badge',
  patch_detail:'admin/badge-detail',
  create_milestone:'admin/create-milestone',
  list_milestone:'admin/list-milestone',
  update_milestone:'admin/milestone',
  delete_milestone:'admin/milestone',
  milestone_detail:'admin/milestone-detail',
  offer_list:'admin/list-offer',
  create_offer:'admin/create-offer',
  update_offer:'admin/update-offer',
  delete_offer:'admin/delete-offer',
  offer_detail:'admin/offer-detail',
  offer_category_list:'admin/offer-category-list',
  offer_category_add:'admin/offer-category',
  offer_category_delete:'admin/offer-catgeory',
  offer_category_update:'admin/offer-category',
  offer_category_detail:'admin/offer-category-detail',
  redeemed_user_list:'admin/redeemed-user-list',
  guide_event_category:'admin/category',
  guide_request_list:'admin/guide-request',
  accept_reject_guide_request:'admin/accept-reject-request',
  guide_request_detail:'/admin/guide-request',
  event_list:'admin/event',
  guide_list:'admin/guide-list',
  csv_app_open_events:'admin/app-open-events',
  csv_bingo_card_dowloads:'admin/bingo-card-downloads',
  csv_trial_checkins:'admin/trail-checkins',
  csv_bingo_card_completion:'admin/bingo-card-completion',
  csv_funactivity_downloads:'admin/funactivity-downloads',
  csv_activities_checkins:'admin/activities-checkins',
  csv_funactivity_completion:'admin/funactivity-completion',
  csv_daily_quest:'admin/daily-quest',
  csv_badge:'admin/badge',
  csv_user_data:'admin/user-data',
  event_detail:'admin/event-detail',
  event_csv:'admin/event-data',
  guide_detail:'admin/user-profile',
  update_guide:'admin/guide-profile-update',
  app_versions:'admin/app-version',
  remove_notification:'admin/cancel-scheduler',
  get_app_settings:'auth/app-settings',
  save_faq:'admin/app-settings'
});
